import { createReducer, on } from "@ngrx/store";
import { arcgisItemsSearch } from "../actions/tab-arcgis-items.actions";
const initialState = null;
export const arcgisItemsTabReducer = createReducer(initialState, on(arcgisItemsSearch, (state, action) => action.value));
